import { render, staticRenderFns } from "./ProjectThumbnail.vue?vue&type=template&id=cb30ae66"
import script from "./ProjectThumbnail.vue?vue&type=script&lang=js"
export * from "./ProjectThumbnail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports